<pdf-viewer [src]="pdfSrc"
    [original-size]="false"
    style="width: 100%; height: 100%;">
</pdf-viewer>
